<template>
  <b-card title="Counter Order List">

     <b-modal
        id="promptDownload"
        ref="modal"
        v-model="promptDownload"
        title="Download"
        hide-footer
      >
      <strong v-if="downloadLoading">Loading Data...</strong>
      <strong v-else-if="orderToDownload.length<=0">No data found. Please try adjusting your search filters.</strong>
      <strong v-else>Loading data finished, total data is {{orderToDownload.length}}</strong>
      <div style="display: table; margin: 0 auto;">
        <b-button :disabled="orderToDownload.length<=0" variant="primary" style="margin-top:20px">
          <download-excel  :data="orderToDownload" :fields="filter" name="Counter Order.xls" class="download-border">download</download-excel>  
        </b-button>
      </div>
      </b-modal> 

    <b-col cols="12">
      <b-row>
        <b-col cols="5">
          Start Date
          <b-form-datepicker  @input="(value) => fireFiltering('startDate', value)" :max="maxDate" v-model="startDate"/>
        </b-col>
        <b-col cols="5">
          End Date
          <b-form-datepicker  @input="(value) => fireFiltering('endDate', value)" :max="maxDate" v-model="endDate"/>
        </b-col>
        <b-col cols="2">
            <!-- <b-button variant="primary" style="margin-top:20px" @click="promptDownload=true">
              <feather-icon size="1x" icon="DownloadIcon" /> Download
            </b-button> -->
            <b-button variant="primary" style="margin-top:20px" @click="openDownloadModal">
              Download
            </b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col style="margin: 15px 0 0 0" cols="12">
          <b-table
            :items="ekioskReport"
            :fields="fields"
            :busy.sync="tableLoading"
            show-empty
            empty-text="Data Not Found"
          >
          <template #cell(items)="row">
            <div v-for="(model, index) in row.item.items" :key="index" style="margin-bottom: 6px;">
              {{ parseFloat(model.totalPrice.$numberDecimal) != 0 ? `${model.model} (${model.updatedQty ? model.updatedQty : model.qty})` : `${model.replacementItem ? model.replacementItem.itemModel : ""} (${model.updatedReplacementQty ? model.updatedReplacementQty : model.qty})` }}
            </div>
          </template>
          <template #cell(totalPriceItem)="row">
            {{ '$' + formatter(parseFloat(row.item.totalPriceItem.$numberDecimal)) }}
          </template>
          <template #cell(createdAt)="row">
            {{ dates(row.item.createdAt) }}
          </template>
          <template #cell(orderStatus)="row">
            {{ row.item.orderStatus ? row.item.orderStatus : 'New' }}
          </template>
          </b-table>
        </b-col>


        <b-col cols="12">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            @change="onPageChange"
            v-model="currentPage"
            style="float: right"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import {userAccess,dateFormat} from '@/utils/utils'
import axios from '@/axios';
import lodash from 'lodash';

export default {
  data() {
    return {
      orderToDownload:[],
      downloadLoading:false,
      fields: [
        { key: 'PONumber', label: 'PO Number', filterable: true, sortable: true },
        { key: 'sapSo', label: 'SO Number', filterable: true, sortable: true },
        { key: 'customerDetail.firstName', label: 'Customer Name', filterable: true, sortable: true },
        { key: 'orderStatus', label: 'Status', filterable: true, sortable: true, },
        { key: 'items', label: 'Items (qty)', filterable: true, sortable: true},
        { key: 'totalQty', label: "Total Quantity", filterable: true, sortable: true},
        { key: 'totalPriceItem', label: "Total Price", filterable: true, sortable: true},
        { key: 'createdAt', label:'Kiosk PO Created Date', filterable: true, sortable: true},
      ],
      filter: {
        'PO Number'             : "PONumber",
        'SO Number'             : 'sapSo',
        'Customer Name'         : 'customerDetail.firstName',
        'Status'                : 'orderStatus',
        'Items (qty)'           : 'items',
        'Total Quantity'        : 'totalQty',
        'Total Price'           : 'totalPriceItem',
        'Kiosk PO Created Date' : 'createdAt',
      },
      promptDownload: false,
      pageOptions: [5, 10, 20],
      search: '',
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      tableLoading: true,
    }
  },
  mounted() {
    
  },
  computed: {
    ...mapGetters({
      ekioskReport : 'ekioskReport/order'
    }),
    ...mapState({
      filterOrder: (state) => {
        if (state.filter.filterContainer['ekiosk-report-online-order'] !== undefined) {
          let orderFilter = state.filter.filterContainer['ekiosk-report-online-order'];
          return orderFilter;
        }

        return {};
      },
    }),
    reactiveStartDate: {
      get() {
        if(this.filterOrder.startDate === undefined){
          this.filterOrder.startDate = this.startDate
        }
        return this.filterOrder.startDate;
      },
      set() {
        this.updateFilterOrder({
          name: 'ekiosk-report-online-order',
          data: {
            startDate: this.filterOrder.startDate
          }
        });
      }
    },
    reactiveEndDate: {
      get() {
        if(this.filterOrder.endDate === undefined){
          this.filterOrder.endDate = this.endDate;
        }
        return this.filterOrder.endDate;
      },
      set() {
        this.updateFilterOrder({
          name: 'ekiosk-report-online-order',
          data: {
            endDate: this.filterOrder.endDate
          }
        });
      }
    },  
  },
  methods: {
    ...mapActions({
      getEkioskReport : 'ekioskReport/getOrder',
      getFilterOrder: 'filter/getFilter',
      updateFilterOrder: 'filter/updateFilter'
    }),
    formatter(value) {
      var number = value;
      if (!number) {
        number = 0;
      }
      return (Math.round(number * 100) / 100).toFixed(2);
    },
    dates(date) {
      //console.info(date);
      return dateFormat(date);
    },
    openDownloadModal(){
      this.promptDownload=true;
      this.downloadLoading=true;
      this.getEkioskReport({
        startDate : this.reactiveStartDate, 
        endDate : this.reactiveEndDate,
        poNumber : 'counter',
        forDownload:true
       
      }).then((data) => {
        this.downloadLoading=false;
        this.orderToDownload=data.data.map(el => {
          return {
            ...el,
            totalPriceItem : "$" + this.formatter(parseFloat(el.totalPriceItem.$numberDecimal)),
            items: el.items.map(item => parseFloat(item.totalPrice.$numberDecimal) != 0 ? `${item.model} (${item.updatedQty ? item.updatedQty : item.qty})` : `${item.replacementItem ? item.replacementItem.itemModel : ""} (${item.updatedReplacementQty ? item.updatedReplacementQty : item.qty})` ),
            createdAt : this.dates(el.createdAt),
            orderStatus: el.orderStatus? el.orderStatus : 'New',
          }
        });
      });

    },
    onPageChange(page) {
      this.currentPage=page;
      this.getEkioskReport({
        startDate : this.filterOrder.startDate, 
        endDate : this.filterOrder.endDate,
        poNumber : 'counter',
        page: this.currentPage, 
        entry: this.perPage,
        refCode:this.search,
       
      }).then((data) => this.processMetadata(data.metadata));
    },
    processMetadata(metadata) {
      let { totalData } = metadata;
      this.totalRows = totalData;
      this.tableLoading = false;
    },
    saveFilter(key, value) { //save filter yang terupdate
      let tempFilter = this.filterOrder; 

      if (value === null) {
        tempFilter[key] = undefined;
      } else {
        tempFilter[key] = value;
      }
      
      this.updateFilterOrder({ //save aja ini ke store filter sendiri
        name: 'ekiosk-report-online-order',
        data: { ...tempFilter,entry: this.perPage,page:1 }
      });
    },
    fireFiltering(key, value) {
      this.saveFilter(key, value); //filter tanggal simpan
      
      let filter = this.filterOrder; //cari ini
      this.currentPage = 1
      this.busyLoading = true;
      this.getEkioskReport({ ...filter,poNumber : 'counter',entry: this.perPage,page:1})
      .then((data) => this.processMetadata(data.metadata));
    },
    refCodeFiltering: lodash.debounce(function (value){
      this.search=value;

      this.getEkioskReport({
        startDate : this.reactiveStartDate, 
        endDate : this.reactiveEndDate,
        poNumber : 'counter',
        page: 1, 
        entry: this.perPage,
        refCode:this.search,
       
      }).then((data) => this.processMetadata(data.metadata));
    },500)
  },
  created() {
    this.getFilterOrder('ekiosk-report-online-order');
    let now = new Date();
    let yearAgo = new Date(now.getFullYear()-1, now.getMonth()+1, now.getDate())
    let monthAgo= new Date();
    monthAgo.setMonth(monthAgo.getMonth()-1);

    
    this.maxDate = now;
    this.startDate = monthAgo;
    this.endDate = now
    
    document.title = 'Counter Order Report | RSP'
    this.getEkioskReport({
      startDate : this.reactiveStartDate, 
      endDate : this.reactiveEndDate,
      poNumber : 'counter',
      page: this.currentPage, 
      entry: this.perPage,
       
      }).then((data) => this.processMetadata(data.metadata));
  },
}
</script>
